var cifIe = ["301 151", "<g fill='none'><path fill='#009B48' d='M.5.5h100v150H.5z'/><path fill='#FFF' d='M100.5.5h100v150h-100z'/><path fill='#FF7900' d='M200.5.5h100v150h-100z'/></g>"];

export { cifIe };

